<template>
	<b-modal
		v-model="vmodel"
		hide-footer
		size="lg"
		title="Tipos de cambio"
		@show="loadExchangeRates"
	>
		<b-form @submit="updateCurrenciesSettings">
			<FormGroupBox title="Moneda Tarifa > Moneda Cotizacion">
				<b-form-row
					class="mt-2 d-flex align-items-center text-center"
					v-for="(comb,
					i) in exchangeRatesCombinations"
					:key="i"
				>
					<b-col cols="4">
						<span class="h4"
							><strong
								class="text-uppercase"
								>{{
									comb.fromCurrencyCode
								}}</strong
							>
							to
							<strong
								class="text-uppercase"
								>{{
									comb.toCurrencyCode
								}}</strong
							></span
						>
					</b-col>
					<b-col cols="1">
						<span class="h4">
							<md-icon icon="chevron_right" />
						</span>
					</b-col>
					<b-col cols="2">
						<b-form-select
							size="sm"
							:disabled="!$hasPermission('currentExchangeRate.edit')"
							v-model="comb.unitCurrency"
							:options="[
								{
									value: 'from',
									text: `1 ${comb.fromCurrencyCode.toUpperCase()}`
								},
								{
									value: 'to',
									text: `1 ${comb.toCurrencyCode.toUpperCase()}`
								}
							]"
						/>
					</b-col>
					<b-col cols="1">
						<span class="h3">=</span>
					</b-col>
					<b-col>
						<b-input-group size="sm">
							<template #prepend
								><b-input-group-text
									>$</b-input-group-text
								></template
							>
							<b-form-input
								type="number"
								:disabled="!$hasPermission('currentExchangeRate.edit')"
								v-model="comb.amount"
								size="sm"
								required
								step=".001"
							/>
							<template #append
								><b-input-group-text
									class="text-uppercase"
									>{{
										comb.unitCurrency ==
										"from"
											? comb.toCurrencyCode
											: comb.fromCurrencyCode
									}}</b-input-group-text
								></template
							>
						</b-input-group>
					</b-col>
				</b-form-row>
			</FormGroupBox>
			<div class="text-right">
				<b-button :disabled="!$hasPermission('currentExchangeRate.edit')" type="submit" variant="primary"
					>Actualizar</b-button
				>
			</div>
		</b-form>
		<b-overlay :show="loading" no-wrap></b-overlay>
	</b-modal>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
// import api from '../../../api.js'

export default {
		props: {
			value: Boolean,
		},
		components: { 
			FormGroupBox,
		},
		data(){
			return {
				loading:false,
				currencies:[
					'usd',
					'mxn',
				],
				modelExchangeRates: [],
				exchangeRatesCombinations:[],
				// vmodel:true,
			}
		},
		methods:{
			loadExchangeRates() {
				// actualiza las monedas validas y después los tipos de cambio
				// ev.preventDefault();
				this.loading = true;
				this.$root.api
					.get(
						`settings/point-of-sales-exchange-rates`
					)
					.then(res => {
						this.exchangeRatesCombinations = res.data;
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			},
			updateCurrenciesSettings(ev) {
				// actualiza las monedas validas y después los tipos de cambio
				ev.preventDefault();
				this.loading = true;
				this.$root.api
					.put(
						`settings/point-of-sales-exchange-rates`,
						{ exchangeRates: this.exchangeRatesCombinations }
					)
					.then(() => {
						this.$root.showAlert("Tipos de cambio actualizado");
						this.loadExchangeRates();
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);

			},
		},
		mounted(){
		},
		computed:{
			vmodel: {
				get() {
					console.log(this.value)
					return this.value;
				},
				set(v) {
					this.$emit("input", v);
				}
			}
		},
		watch: {
			// modelExchangeRates: function() {
			// 	this.generateExchangeRatesCombinations();
			// },
		}
}
</script>

<style>

</style>
